/* eslint-disable max-classes-per-file*/
export class ReplaceWhiteSpaceValueConverter {
	public toView(value) {
		let replacementStr;

		replacementStr = value.toString().replace(' ', '-');
		replacementStr = replacementStr.replace('\n', '_');

		return replacementStr;
	}
}

// tslint:disable:max-classes-per-file
export class StringEqualsValueConverter {
	public toView(value, valueToCompare) {
		if (value == null || valueToCompare == null) {
			return false;
		}
		return value.toString() === valueToCompare.toString();
	}
}

export class DisplayIfTrueValueConverter {
	public toView(condition, str, otherwise) {
		if (condition === true) {
			return str;
		}
		return otherwise ? otherwise : '';
	}
}
